
define('text!plugins/templates/collegeTransfers_p1TotalTemplate_table.html!strip',[],function () { return '<h5>Number of Transfer Students</h5>\n\t\t{{#data.p1Total.data}}\n\t\t\t{{formattedCount}}\n\t\t{{/data.p1Total.data}}\n\t\t\n\t';});

